import { Button, Heading, Section } from 'components'
import { graphql } from 'gatsby'
import Img from 'gatsby-image'
import React from 'react'
import {
  RiArrowLeftRightLine,
  RiCheckboxMultipleFill,
  RiListSettingsFill,
} from 'react-icons/ri'

const IntegrationSingle = ({ data }) => {
  const { title, content, featuredImage } = data.content

  return (
    <>
      <Section>
        {featuredImage && (
          <div className="w-32 mx-auto">
            <Img fluid={featuredImage.node.localFile.childImageSharp.fluid} />
          </div>
        )}
        <div className="text-center mt-8">
          <Heading level="1" className="text-5xl">
            {title}
          </Heading>
        </div>
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </Section>
      <Section>
        <div className="grid grid-cols-3 gap-8">
          <div className="p-8 border rounded space-y-4">
            <RiCheckboxMultipleFill className="fill-current  text-primary-600 text-5xl p-2 bg-primary-50 rounded-full" />
            <Heading level="5">Included in all plans</Heading>
            <p>
              This integration is available in all plans and packages. Detailed
              documentation is available in our help section.{' '}
            </p>
          </div>

          <div className="p-8 border rounded space-y-4">
            <RiArrowLeftRightLine className="fill-current  text-primary-600 text-5xl p-2 bg-primary-50 rounded-full" />
            <Heading level="5">Transport your data</Heading>
            <p>
              Use this integration to get your data flowing into Leadboxer, we
              will automatically capture and enrich all your leads and
              customers.
            </p>
          </div>

          <div className="p-8 border rounded space-y-4">
            <RiListSettingsFill className="fill-current  text-primary-600 text-5xl p-2 bg-primary-50 rounded-full" />
            <Heading level="5">Easy configuration</Heading>
            <p>
              All integrations are designed to make setup as easy as possible.
              If you like, we can always help and set things up together.
            </p>
          </div>
        </div>
      </Section>
      <Section background="bg-primary-800" className="text-center">
        <div className="max-w-3xl mx-auto">
          <Heading level="3" className="text-white">
            Would you like to see this in action?
          </Heading>
          <Button type="primary" to="/demo">
            Schedule a Demo
          </Button>
        </div>
      </Section>
    </>
  )
}

export const query = graphql`
  query GET_INTEGRATION($id: String!) {
    content: wpIntegration(id: { eq: $id }) {
      id
      slug
      title
      date(formatString: "MMMM DD, YYYY")
      content
      featuredImage {
        node {
          localFile {
            childImageSharp {
              id
              fluid(maxWidth: 400, maxHeight: 400) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  }
`

export default IntegrationSingle
